import Helpers from "../../commons/helpers";
import MessageClient from "./MessageClient";
import { Constants } from "../../constants/constants";
import { ICategory } from "../../commons/interfaces";

const CategoryService = {
    getAll: async (request: { type?: any; parentCategory?: string; serviceCode: string; tenantCode?: string }): Promise<ICategory[]> => {
        const str = request ? `?${Helpers.handleFormatParams(request)}` : "";
        const result = await MessageClient().get(`${Constants.ApiPath.CATEGORY.GET_ALL}${str}`);
        return result.data.result;
    },

    getPaged: async (request: {
        type?: any;
        orderBy?: string;
        pageSize?: number;
        pageNumber?: number;
        parentCategory?: string;
        serviceCode: string;
        tenantCode?: string;
    }) => {
        const str = Helpers.handleFormatParams(request);
        const result = await MessageClient().get(`${Constants.ApiPath.CATEGORY.GET_PAGED}?${str}`);
        return result.data.result;
    },

    getDetail: async (id: string): Promise<any> => {
        const result = await MessageClient().get(`${Constants.ApiPath.CATEGORY.GET_DETAIL}/${id}`);
        return result.data.result;
    },

    create: async (request: { name: any; type?: number; shortName?: any; serviceCode: string; tenantCode?: string; }) => {
        const result = await MessageClient().post(Constants.ApiPath.CATEGORY.CREATE, request);
        return result.data.result;
    },

    update: async (request: { id: string; name: any; type?: number; shortName?: any }) => {
        const result = await MessageClient().post(Constants.ApiPath.CATEGORY.UPDATE, request);
        return result.data.result;
    },

    delete: async (id: string) => {
        const result = await MessageClient().delete(`${Constants.ApiPath.CATEGORY.DELETE}/${id}`);
        return result.data.result;
    },
};

export default CategoryService;
